import { flatten, includes, intersection, uniqBy } from 'lodash-es'
import { ISO } from 'service/ISO'

import { TCarriageMode, TCarriageType } from '../Carriage'

export type IncoTerm = { code: ISO.IncoTermsCode; description: string }

export enum BookingParty {
  Buyer = 'buyer',
  Seller = 'seller',
}

export type IncoTermMetadata = {
  automatedQuoteIncoterms: IncoTerm[]
  bookingParty: BookingParty
  destination: ('door' | 'port')[]
  manualQuoteIncoterms: IncoTerm[]
  origin: ('door' | 'port')[]
  preferredIncoterm: ISO.IncoTermsCode
  transportMode: TCarriageMode[]
  transportType: TCarriageType[]
}

export enum AddressType {
  Door = 'door',
  Port = 'port',
}

type GetApplicableIncoTermsArgs = {
  bookingParty: BookingParty
  originType: AddressType
  destinationType: AddressType
  transportType: TCarriageType
  transportModes: TCarriageMode[]
}

export const getPreferredIncoTerms = (
  incoTermsList: IncoTermMetadata[],
  request: GetApplicableIncoTermsArgs
): ISO.IncoTermsCode | null => {
  const allApplicableIncoterms = incoTermsList.filter((incoTerm) => {
    if (incoTerm.bookingParty !== request.bookingParty) return false
    if (!includes(incoTerm.origin, request.originType)) return false
    if (!includes(incoTerm.destination, request.destinationType)) return false
    if (!includes(incoTerm.transportType, request.transportType)) return false
    if (intersection(request.transportModes, incoTerm.transportMode).length === 0) return false

    return true
  })

  const preferredIncoterm = allApplicableIncoterms.length === 1 ? allApplicableIncoterms[0].preferredIncoterm : null

  return preferredIncoterm
}

export const getIncotermsList = (incoterms: IncoTermMetadata[]): IncoTerm[] => {
  const manualIncoterms = flatten(incoterms.map((incoTerm) => incoTerm.manualQuoteIncoterms))
  const automaticIncoterms = flatten(incoterms.map((incoTerm) => incoTerm.automatedQuoteIncoterms))

  return uniqBy([...automaticIncoterms, ...manualIncoterms], 'code')
}
